import { Spinner } from "@/components/ui/Spinner";
import { CheckCircle, AlertCircle } from "lucide-react";
import type { PaymentState } from "@/hooks/useArticleContent";

export function PaymentStatus({ state }: { state: PaymentState }) {
  if (state.step === "switching-chain") {
    return (
      <StatusMessage icon={<Spinner className="h-5 w-5 text-orange" />}>
        Switching network...
      </StatusMessage>
    );
  }
  if (state.step === "signing") {
    return (
      <StatusMessage icon={<Spinner className="h-5 w-5 text-orange" />}>
        Sign the payment in your wallet...
      </StatusMessage>
    );
  }
  if (state.step === "submitting") {
    return (
      <StatusMessage icon={<Spinner className="h-5 w-5 text-orange" />}>
        Submitting payment...
      </StatusMessage>
    );
  }
  if (state.step === "error") {
    return (
      <StatusMessage icon={<AlertCircle className="h-5 w-5 text-red-500" />}>
        {state.message}
      </StatusMessage>
    );
  }
  if (state.step === "paid") {
    return (
      <StatusMessage icon={<CheckCircle className="h-5 w-5 text-green" />}>
        Payment confirmed
      </StatusMessage>
    );
  }
  return null;
}

function StatusMessage({
  icon,
  children,
}: {
  icon: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div className="flex items-center gap-3 p-4 rounded-xl bg-white border border-beige/20 my-4">
      {icon}
      <span className="font-body text-sm">{children}</span>
    </div>
  );
}
